import { ComponentProps, FC } from 'react'
import { GENRES } from '../../../../client/Genres'
import { ChevronDown } from '../../../core/icons'
import * as Dropdown from './Dropdown'

interface GenresProps {
  onSelect?: (genre: string) => void
  genres: string[]
}

type GenresDropdownProps = Omit<ComponentProps<typeof Dropdown.Trigger>, 'onSelect'> & GenresProps

const GenresDropdown: FC<GenresDropdownProps> = ({ genres, onSelect, ...props }) => {
  const handleSelect = (genre: string) => (evt) => {
    evt.preventDefault()
    onSelect(genre)
  }
  return (
    <Dropdown.Root dir="ltr">
      <Dropdown.Trigger active={genres.length > 0} {...props}>
        Genres
        <ChevronDown />
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content
          mobile={{ '@initial': true, '@tablet': false }}
          css={{ '@tablet': { width: '586px', maxHeight: '312px' } }}
          side={'bottom'}
          align={'start'}
          sideOffset={4}
        >
          {GENRES.map((genre) => (
            <Dropdown.CheckboxItem
              css={{ '@tablet': { width: '140px' } }}
              key={genre}
              onSelect={handleSelect(genre)}
              checked={genres.includes(genre)}
            >
              {genre}
              <Dropdown.Checkbox />
            </Dropdown.CheckboxItem>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  )
}

export default GenresDropdown
